import common from './common';
import listFormatting from './list-formatting';
import textIndentTriggerIds from './text-indent-trigger-ids';

export default {
  common,
  listFormatting,
  textIndentTriggerIds,
};
